import { TOKEN_UNAVAILABLE_MESSAGE } from '~/helpers/axiosAuth'

export default async ({ store, error }) => {
  if (!store.state.currentUser && store.state.accessToken) {
    try {
      await store.dispatch('setCurrentUser')
    } catch (error) {
      // 握りつぶし(store 側でも握りつぶしている)
    }
  }
  // トークンが一時的に取れない状態ではユーザー情報も取れない(ヘッダー無しの 401)。
  // currentUser 無しのままページを描画するとテンプレートの参照で落ちるので、通信失敗の案内で止める(再読込で復帰できる)
  if (
    !store.state.currentUser &&
    store.state.accessToken &&
    store.state.accessTokenStatus === 'unavailable'
  ) {
    error({ statusCode: 400, message: TOKEN_UNAVAILABLE_MESSAGE })
  }
}
